export default "__VITE_ASSET__DpUDVl0X__"